import { createAction } from "redux-actions";
import { USER_LOGOUT, IMPERSONATION } from "constants/action-types";

export const userLogout = createAction(USER_LOGOUT);

export const fetchImpersonationCode = () => ({
    payload: {},
    type: IMPERSONATION.REQUEST_IMPERSONATION.FETCH.START,
});

export const fetchImpersonationToken = (userData) => ({
    payload: userData,
    type: IMPERSONATION.ENTER_IMPERSONATION.CREATE.START,
});

export const stopImpersonation = () => ({
    payload: {},
    type: IMPERSONATION.STOP_IMPERSONATION.FETCH.START,
});

export const resetImpersonationForm = () => ({
    payload: {},
    type: IMPERSONATION.ENTER_IMPERSONATION.RESET,
});
